import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@services/authentification.service';
import {AlertService} from '@services/alert.service';
import {FormService} from '@services/form.service';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {TOO_MANY_REQUESTS} from '~/app/shared/helpers/error.interceptor';

@Component({
    selector: 'app-new-password',
    templateUrl: './new-password.component.html',
    styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent implements OnInit {
    emailForm: UntypedFormGroup;
    passwordForm: UntypedFormGroup;

    loading = false;
    returnUrl: string;
    hide = true;
    step = 1;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        public authenticationService: AuthenticationService,
        private alertService: AlertService,
        public formService: FormService,
        private http: HttpClient
    ) {
        // redirect to home if already logged in
        if (this.authenticationService.isLogin) {
            this.router.navigate(['/app']);
        }
    }

    ngOnInit() {
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/app';

        this.emailForm = this.formBuilder.group({
            username: ['', [Validators.required, Validators.email]],
        });

        this.passwordForm = this.formBuilder.group({
            code: ['', [Validators.required]],
            password: ['', [Validators.required, Validators.minLength(8)]],
        });
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.emailForm.controls;
    }

    sendCode() {
        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.emailForm.invalid) {
            return false;
        }

        this.loading = true;

        return this.http.post<any>(`${environment.apiUrl}app/forgotPassword`, {
            email: this.emailForm.get('username').value
        }).subscribe(
            data => {
                this.loading = false;
                this.step = 2;
            },
            (error) => {
                if (error === TOO_MANY_REQUESTS) {
                    this.alertService.error('Trop de tentatives, réessayez plus tard.');
                } else {
                    this.alertService.error('Email invalide');
                }
                this.loading = false;
            });
    }

    sendNewPassword() {
        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.passwordForm.invalid) {
            return false;
        }

        this.loading = true;
        return this.http.post<any>(`${environment.apiUrl}app/newPassword`,
            {
                email: this.emailForm.get('username').value,
                code: this.passwordForm.get('code').value,
                password: this.passwordForm.get('password').value,
            }).subscribe(
            data => {
                setTimeout(function() {
                    this.router.navigate(['/app/login'], { queryParams: { forgot: 1 } });
                }.bind(this), 1000);
            },
            (error) => {
                this.loading = false;
                if (error === TOO_MANY_REQUESTS) {
                    this.alertService.error('Trop de tentatives, réessayez plus tard.');
                } else {
                    this.step = 1;
                    this.alertService.error('Code invalide');
                }
            });
    }
}
